// extracted by mini-css-extract-plugin
export default {"navigate":"UserDetails_navigate__mvYkj","userPanel":"UserDetails_userPanel__Nw2ZW","activate":"UserDetails_activate__7xbst","blacklist":"UserDetails_blacklist__jZM6G"};